import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { TextField } from '@material-ui/core';
import styles from 'styles/admin-detail.module.scss';
import { ErrorMessage } from 'components';
import { currentUserSelector } from 'store/current_user'
import { isPermitted } from 'utils/utils';
import { NON_FINANCIAL_FORM_TYPE, NON_FINANCIAL_MESSAGE_TYPE, ALLOWERD_FORM_TYPES_MAP_BY_MESSAGE_TYPE, NON_FINANCIAL_LINE_MESSAGE_TEMPLATE } from "const";
import FormControl from '@material-ui/core/FormControl';
import { Select, MenuItem } from '@material-ui/core';

const FreeChatInput = (props) => {
  const { freeChatInputFormik, lockedBy } = props;
  const currentUser = useSelector(currentUserSelector)

  const isDisabled = () => {
    if (!currentUser) return true;
    return !isPermitted(currentUser, lockedBy)
  }

  const messageType = []
  messageType.push(<MenuItem key={'0'} value={'0'}>&nbsp;</MenuItem>)
  for (const [key, value] of Object.entries(NON_FINANCIAL_MESSAGE_TYPE)) {
    messageType.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
  }

  const filterFormType = (messageType) => {
    const filtered = Object.keys(NON_FINANCIAL_FORM_TYPE)
      .filter(key => ALLOWERD_FORM_TYPES_MAP_BY_MESSAGE_TYPE[messageType].includes(key))
      .reduce((obj, key) => {
        obj[key] = NON_FINANCIAL_FORM_TYPE[key];
        return obj;
      }, {});
    const formType = []
    formType.push(<MenuItem key={'0'} value={'0'}>&nbsp;</MenuItem>)
    for (const [key, value] of Object.entries(filtered)) {
      formType.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
    }
    return formType
  }

  const [formType, setFormType] = useState(filterFormType("all"));

  useEffect(() => {
    setFormType(filterFormType(freeChatInputFormik.values.messageType ? freeChatInputFormik.values.messageType : "all"))
  }, [
    freeChatInputFormik.values.messageType
  ]);

  return (
    <div className={styles.freeChat}>
      <div className={styles.item}>
        <p className={styles.labelTop}>
          チャット種別<span className={styles.required}>必須</span>
        </p>
        <FormControl>
          <Select
            fullWidth
            {...freeChatInputFormik.getFieldProps('messageType')}
            onChange={(event) => {
              if (freeChatInputFormik.values.messageType === 7 &&
                (event.target.value === '4' || event.target.value === '5' || event.target.value === '6')) {
                freeChatInputFormik.setFieldValue('type', null)
              }
              freeChatInputFormik.setFieldValue('messageType', Number(event.target.value))
              freeChatInputFormik.setFieldValue('freeMessage', NON_FINANCIAL_LINE_MESSAGE_TEMPLATE[event.target.value])
              if (event.target.value === '7') {
                freeChatInputFormik.setFieldValue('type', 2)
                freeChatInputFormik.setFieldValue('message', null)
              }
            }}
            value={freeChatInputFormik.values.messageType || 0}
            error={
              !!(
                freeChatInputFormik.touched.messageType &&
                freeChatInputFormik.errors.messageType
              )
            }
            disabled={isDisabled()}
          >
            {messageType}
          </Select>
        </FormControl>
        <ErrorMessage
          touched={freeChatInputFormik.touched.messageType}
          error={freeChatInputFormik.errors.messageType}
        />
      </div>
      <div className={styles.item}>
        <p className={styles.labelTop}>
          LINEメッセージ<span className={styles.required}>必須</span>
        </p>
        <TextField
          fullWidth
          type='text'
          variant='outlined'
          multiline
          rows={5}
          {...freeChatInputFormik.getFieldProps('freeMessage')}
          onChange={(event) => {
            freeChatInputFormik.setFieldValue('freeMessage', event.target.value)
          }}
          value={freeChatInputFormik.values.freeMessage || ''}
          error={
            !!(
              freeChatInputFormik.touched.freeMessage &&
              freeChatInputFormik.errors.freeMessage
            )
          }
          disabled={isDisabled()}
        />
        <ErrorMessage
          touched={freeChatInputFormik.touched.freeMessage}
          error={freeChatInputFormik.errors.freeMessage}
        />
      </div>
      {(freeChatInputFormik.values.messageType !== 7) && (
        <>
          <div className={styles.item}>
            <p className={styles.labelTop}>
              回答フォーム種別<span className={styles.required}>必須</span>
            </p>
            <FormControl>
              <Select
                value={freeChatInputFormik.values.type || 0}
                {...freeChatInputFormik.getFieldProps('type')}
                onChange={(event) => {
                  freeChatInputFormik.setFieldValue('type', Number(event.target.value))
                }}
                error={
                  !!(
                    freeChatInputFormik.touched.type &&
                    freeChatInputFormik.errors.type
                  )
                }
                disabled={isDisabled()}
              >
                {formType}
              </Select>
            </FormControl>
            <ErrorMessage
              touched={freeChatInputFormik.touched.type}
              error={freeChatInputFormik.errors.type}
            />
          </div>
          <div className={styles.item}>
            <p className={styles.labelTop}>
              回答フォームメッセージ<span className={styles.required}>必須</span>
            </p>
            <TextField
              fullWidth
              type='text'
              variant='outlined'
              multiline
              rows={5}
              {...freeChatInputFormik.getFieldProps('message')}
              onChange={(event) =>
                freeChatInputFormik.setFieldValue('message', event.target.value)
              }
              value={freeChatInputFormik.values.message || ''}
              error={
                !!(
                  freeChatInputFormik.touched.message &&
                  freeChatInputFormik.errors.message
                )
              }
              disabled={isDisabled()}
            />
            <ErrorMessage
              touched={freeChatInputFormik.touched.message}
              error={freeChatInputFormik.errors.message}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default FreeChatInput;
